export default "__VITE_ASSET__DJkP9y0q__"